import { createFileRoute, notFound, redirect } from '@tanstack/react-router';

// 옮긴 화면의 옛 주소 → 새 주소. 북마크·공유된 옛 주소를 쿼리·해시까지 그대로 새 주소로 보낸다.
// 내부 CPM 전용 화면은 /cm/internal 아래로 옮겼고, 발송 일정은 이메일 템플릿 화면에 합쳐졌다.
const MOVED_SECTIONS: Record<string, string> = {
  'alignment-calls': 'internal/alignment-calls',
  'coach-list': 'internal/coach-list',
  'company-status': 'internal/company-status',
  'console-data': 'internal/console-data',
  email: 'internal/email',
  insights: 'internal/insights',
  'notification-templates': 'internal/notification-templates',
  'notification-schedules': 'internal/notification-templates'
};
export const Route = createFileRoute('/cm/$')({
  beforeLoad: ({
    location
  }) => {
    const section = location.pathname.split('/')[2] ?? '';
    const movedTo = MOVED_SECTIONS[section];
    if (movedTo) {
      throw redirect({
        href: location.href.replace(`/cm/${section}`, `/cm/${movedTo}`),
        replace: true
      });
    }
    throw notFound();
  }
});